import { render, staticRenderFns } from "./ViqLensSelector.vue?vue&type=template&id=6fba323f&scoped=true"
import script from "./ViqLensSelector.vue?vue&type=script&lang=js"
export * from "./ViqLensSelector.vue?vue&type=script&lang=js"
import style0 from "./ViqLensSelector.vue?vue&type=style&index=0&id=6fba323f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fba323f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fba323f')) {
      api.createRecord('6fba323f', component.options)
    } else {
      api.reload('6fba323f', component.options)
    }
    module.hot.accept("./ViqLensSelector.vue?vue&type=template&id=6fba323f&scoped=true", function () {
      api.rerender('6fba323f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqLensSelector.vue"
export default component.exports